var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"transition":"scale-transition","max-width":"400"},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-btn',_vm._g({attrs:{"icon":""}},on),[_c('v-icon',[_vm._v("apps")])],1)]}}])},[_c('apps-card-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }